<template>
  <Outer>
    <div class="b-auth">
      <h2 class="b-title _center">
        <template v-if="username">
          {{
            $t('auth---Welcome, {username}!', {username})
          }}
        </template>
        <template v-else>{{ $t('auth---Welcome!') }}</template>
      </h2>
      <p class="b-text _note _center">
        {{ $t('auth---Contact your curator to restore access') }}
      </p>
      <div class="b-row _space_above _centered">
        <a href="#" @click.prevent="$router.push({ name: 'auth-log-in' })"
           class="b-link">{{ $t('auth---Back to main page') }}</a>
      </div>
    </div>
  </Outer>
</template>

<i18n src="../i18n/translations/codePage.json"></i18n>

<script>
import Outer from './../components/Outer.vue';

export default {
  components: {
    Outer
  },
  data() {
    return {
      username: this.$store.state.username
    };
  },
};
</script>
